<template>
    <div class="modal is-active"  >
        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title " v-if="mode =='I'" >New Insert Mode </p>
                <p class="modal-card-title " v-if="mode =='U'" >Edit Mode</p>
                <button class="delete" aria-label="close" @click="closeBtn"></button>
            </header>
            <section class="modal-card-body">

                <b-field label="Methods name">
                    <b-input v-model="dataModel.name" >{{dataModel.name}}</b-input>
                </b-field>
                <b-field label="Status">
                    <b-switch  type="is-success" v-model="dataModel.enable">{{status_caption}}</b-switch>
                </b-field>

                <hr>
                <nav class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <b-button type="is-success is-light"
                                      icon-right="plus"
                                      @click="addNewValue"
                            />

                        </div>
                        <div class="level-item">
                         <p class="has-text-success-dark">Add New Value</p>
                        </div>

                    </div>
                    <div class="level-right">

                    </div>
                </nav>


                <b-field label="Value" v-for="(data,idx) in dataModel.data" :key="data.uuid">
                    <b-input v-model="dataModel.data[idx].data" >{{data.data}}</b-input>
                    <p class="control">
                        <b-button type="is-danger is-light"
                                  icon-right="delete"
                                  @click="deleteValue(data.uuid)"
                        />
                    </p>
                </b-field>





            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">
                <b-button type="is-danger"  @click="closeBtn">Cancel</b-button>
                <b-button type="is-success"  @click="Update">Update</b-button>
            </footer>
        </div>
    </div>
</template>

<script>

    import { getBaseURLforBackEnd , getConfigAxios , genUUID }  from '@/utils.js'
    import axios from "axios";
    import { mapState } from "vuex";

    export default {
        name: "EditAddMethodsOrgaAndFunc",
        props:{
            dataMethods:  Object,  // {"id":"","name":"","enable": "","data":[{"id":"","data":""}]} ,
            mode : String, // 'I' === insert , 'U' === Update
            isShowing : Boolean
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        methods:{
            closeBtn(){
                this.$emit('closeAddMethodsBactAndFunc')
            },
            Update(){
                // { "mode": "I",
                //     "id": 1,
                //     "name": " 555",
                //     "enable": true,
                //     "data": [ { "id": 1, "data": "+a1", "uuid": "13ahuQ1Qrw6j" },
                //               { "id": 2, "data": "+a2", "uuid": "gYLcY65z96zH" },
                //               { "id": 3, "data": "+a3", "uuid": "ZcUjcxpOlchq" },
                //               { "id": "", "data": "+a4", "uuid": "ic1nflm85f0Y" }
                //               ] }


                // {"id":1,
                // "name":"ตรวจหาเชื้อแบคทีเรียทั่วไป 555",
                // "enable":true,
                // "data":[{"id":12,"data":"+1","uuid":"lQliNcMHaJ17"},
                //         {"id":13,"data":"+2","uuid":"gVmcMM4wWy7s"},
                //         {"id":14,"data":"+3","uuid":"NDDawjkgncKg"},
                //         {"id":15,"data":"+4","uuid":"0KU6kRVY4ZQ7"}
                //         ]}


                this.dataModel.mode = this.mode.toUpperCase()
                // console.log(JSON.stringify(this.dataModel))

                this.isFullScreenSearching = true
                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/update_or_addnew_methods_orga`, this.dataModel, getConfigAxios())
                    .then((res)=>{
                        this.$buefy.dialog.alert({
                            title: 'Message',
                            message: `${res.data.msg}`,
                            type: 'is-success',
                            hasIcon: true,
                            icon: 'check',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        vm.isFullScreenSearching = false
                        vm.$emit('closeAddMethodsBactAndFuncWithData')
                    })

                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        vm.isFullScreenSearching = false
                    })

                // this.$emit('closeAddMethodsBactAndFuncWithData')
            },
            addNewValue(){
                this.dataModel.data.push({"id":"","data":"","uuid": genUUID(12)})
            },
            deleteValue(_id){
                // console.log(_id)
                const datMember = this.dataModel.data.find(dat=>{
                   return  dat.uuid === _id
                })

                if(datMember){
                    const dataMemberIndex = this.dataModel.data.indexOf(datMember)
                    this.dataModel.data.splice(dataMemberIndex,1)
                }

            }
        },
        data(){
            return {
                isFullScreenSearching : false,
                status_caption: "",
                dataModel : {},
            }
        },
        watch:{
            isShowing:{
                immediate : true,
                handler: function (val) {
                   if(val){
                       this.dataModel =JSON.parse(JSON.stringify(this.dataMethods))
                       this.status_caption = this.dataModel.enable ? 'ใช้งาน' : 'ยกเลิก'
                   }
                }
            },
            'dataModel.enable' :{
                deep : true,
                handler: function (val) {
                    this.status_caption = val ? 'ใช้งาน' : 'ยกเลิก'
                }
            }
        }
    }
</script>

<style scoped>

</style>